var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMultimedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_981",
    "data-name": "Grupo 981",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_201",
    "data-name": "Rect\\xE1ngulo 201",
    width: 45,
    height: 45,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NAB86B.tif",
    transform: "translate(3.301 8.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_980",
    "data-name": "Grupo 980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_434",
    "data-name": "Trazado 434",
    d: "M3.3,9.777c.074-.25.133-.5.223-.749a4.337,4.337,0,0,1,4.2-2.66c9.29,0,18.579.02,27.869-.014,2.579-.01,4.544,1.724,4.567,3.673.013,1.041.03,2.083.006,3.124a.861.861,0,0,1-1.252.717.745.745,0,0,1-.5-.749c.009-.935.006-1.871,0-2.806C38.4,8.863,37.321,7.9,35.642,7.9q-13.894-.01-27.788,0C6.161,7.9,5.1,8.844,5.1,10.31q0,8.063,0,16.124v.393H23.367c.681,0,1.078.345,1,.864a.736.736,0,0,1-.674.627,3.675,3.675,0,0,1-.613.033q-8.694,0-17.388,0H5.12A1.833,1.833,0,0,0,5.713,29.8a2.843,2.843,0,0,0,2.14.808q7.706-.012,15.414,0c.642,0,1.028.237,1.087.659a.792.792,0,0,1-.784.879,2.747,2.747,0,0,1-.327.008q-7.687,0-15.374,0a4.342,4.342,0,0,1-4.438-2.963c-.042-.146-.087-.292-.131-.438Z",
    transform: "translate(-3.301 -6.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_435",
    "data-name": "Trazado 435",
    d: "M26.969,33.646a11.694,11.694,0,0,1-1.365-.458,4.533,4.533,0,0,1,1.217-8.564,14.867,14.867,0,0,1,1.506-.091V14.947c0-.864.456-1.183,1.262-.885L35.9,16.4c.687.254.8.419.8,1.147q0,1.9,0,3.8c0,.766-.46,1.1-1.191.853q-1.51-.5-3.021-1.009c-.1-.033-.2-.06-.337-.1v.408c0,2.461-.02,4.923.006,7.384a4.581,4.581,0,0,1-3.825,4.711c-.029,0-.055.039-.082.059Zm2.906-17.839V16.3c0,3.054-.012,6.109.009,9.162a.834.834,0,0,1-1.21.838,2.381,2.381,0,0,0-.962-.2,3.006,3.006,0,0,0-2.5,4.858,2.847,2.847,0,0,0,3.031,1.08,2.942,2.942,0,0,0,2.356-2.97q.007-4.44,0-8.878c0-.765.458-1.089,1.187-.848l.235.08,3.126,1.033c0-.831-.009-1.621.006-2.41.005-.234-.084-.321-.293-.394-.735-.258-1.462-.54-2.193-.81C31.753,16.5,30.836,16.161,29.875,15.807Z",
    transform: "translate(1.699 -6.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_436",
    "data-name": "Trazado 436",
    d: "M14.318,17.719q0-2.184,0-4.368a1.433,1.433,0,0,1,2.2-1.306q3.834,2.188,7.647,4.414a1.428,1.428,0,0,1,0,2.546q-3.813,2.226-7.647,4.415a1.432,1.432,0,0,1-2.206-1.3Q14.314,19.921,14.318,17.719Zm1.551-4.288v8.6l7.454-4.3Z",
    transform: "translate(-0.881 -6.354)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMultimedia);
export default __webpack_public_path__ + "static/media/ic_multimedia.bfca2212d2d39be19787788654977010.svg";
export { ForwardRef as ReactComponent };